import React from 'react'
import PropTypes from 'prop-types'
import AvatarWrapper from 'ui/partials/AvatarWrapper'

function EmployeeInfo ({
  children,
  title,
  text,
  avatar,
  badges = null,
  large = false,
  active = false,
  width = 'w-1/4',
  className = ''
}) {
  const titleElement = title || children ? <div className='font-medium leading-5 truncate'>{title || children}</div> : null
  const textElement = text ? <div className='text-sm text-gray-500 leading-5 truncate'>{text}</div> : null

  return (
    <div className={'flex items-center w-full ' + className}>
      <AvatarWrapper active={active} large={large}>
        {avatar}
      </AvatarWrapper>
      <div className={'group space-y-1 flex-grow pr-5 ' + width}>
        {titleElement}
        {textElement}
      </div>
      {badges !== null
        ? (
          <div className={'group space-y-1 flex-grow pr-5 ' + width}>
            {badges}
          </div>
          )
        : null}
    </div>
  )
}

EmployeeInfo.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  badges: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ])
}

export default EmployeeInfo
